import colors from "../../colors";
import React, {useEffect, useState} from "react";
import Icon from "@material-ui/core/Icon";


function computePosition(ihp, ivp, iiw, iih, ciw, cih) {
    /*
       ihp - Initial Horizontal Position
       ivp - Initial Vertical Position
       iiw - Initial Image Width
       iih - Initial Image Height
       ciw - Current Image Width
       cih - Current Image Height

       returns:
       chp - Current Horizontal Position
       cvp - Current Vertical Position
       */
    let chp = (ihp / iiw) * ciw,
        cvp = (ivp / iih) * cih;
    return [Math.floor(chp), Math.floor(cvp)];
}

function computeStyleFor(page, spec, dimensions) {
    if (!dimensions.width) {
        return {display: 'none'};
    }
    let x = spec.position_x;
    let y = spec.position_y;

    let dimns = computePosition(x, y, page.detail.page_width, page.detail.page_height, dimensions.width, dimensions.height);
    let percentBiggerX = dimensions.width / page.detail.page_width;
    let percentBiggerY = dimensions.height / page.detail.page_height;
    let hh = spec.height * percentBiggerY;
    if (isNaN(percentBiggerX)) {
        percentBiggerX = 1;
    }
    if (isNaN(percentBiggerY)) {
        percentBiggerY = 1;
    }
    let top = dimns[1] - (hh / 2);
    if (spec.type === "manual_position") {
        hh = spec.height * percentBiggerY;
        top = dimns[1] - (hh);
    }
    // console.log(dimns[0], dimns[1], x, y, percentBiggerY, percentBiggerX, page.detail.page_width, page.detail.page_height, dimensions.width, dimensions.height);

    return {
        left: dimns[0],
        top: top,
        width: spec.width * percentBiggerX,
        height: hh
    };
}


function hexToRgbA(hex, opacity) {
    var c;
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split('');
        if (c.length === 3) {
            c = [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c = '0x' + c.join('');
        return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ', ' + opacity + ')';
    }
    throw new Error('Bad Hex');
}

function getColorByIndex(index, opacity = 0.4) {
    return hexToRgbA(colors[index], opacity);
}


const styles = {
    root: {
        flexGrow: 1,
    },
    grow: {
        flexGrow: 1,
    },
    menuButton: {
        marginLeft: -12,
        marginRight: 20,
    },
};

function useFractalWidth() {
    let [mw, setMw] = useState(0);

    useEffect(() => {
        let handler = () => {
            let cw = window.innerWidth;
            let d = cw * 0.3;
            let sw = cw - d;
            if (cw < 600) {
                sw = cw;
            }
            setMw(sw);
        };
        handler();
        window.addEventListener("resize", handler);
        return () => {
            window.removeEventListener("resize", handler);
        };
    }, []);

    return [mw, setMw];
}

let arrowPositions = {
    up: <Icon color={"primary"} fontSize="large">keyboard_arrow_up</Icon>,
    down: <Icon color={"primary"} fontSize="large">keyboard_arrow_down</Icon>,
    left: <Icon color={"primary"} fontSize="large">keyboard_arrow_left</Icon>,
    right: <Icon color={"primary"} fontSize="large">keyboard_arrow_right</Icon>
};

let isInViewport = (elem) => {
    let bounding = elem.getBoundingClientRect();
    let has = (
        bounding.top >= 0 &&
        bounding.left >= 0 &&
        bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
    if (!has) {
        return false;
    }
    return bounding;
};

export {
    styles, isInViewport, arrowPositions, useFractalWidth, getColorByIndex, hexToRgbA, computeStyleFor, computePosition,
}